import React, { Component } from 'react';
import config from 'react-global-configuration';
import getLocale from '../../../i18n/getLocale';
import RequestApi from '../../Miscelania/RequestApi';

class TrainingStaffObservations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      id: this.props.training_certification_staff_id,
      observations: this.props.observations,
      status: this.props.status,
    };

    this.locale = getLocale();

    //bind específico
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  // LM
  
  // Salva edição de comentário
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/aluno/comentario/editar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
      <div>
        {(this.props.status === 1 || this.props.status === 3) ? 
          <form onSubmit={this.edit} className="row"> 
            <RequestApi ref={'request_api'} />
            <div className="col-md-9 col-md-offset-1">
              <textarea style={{ height: 66 }} type="text" placeholder={this.locale.Treinamentos.EditarTreinamento.tabAlunos.formularioObservacoes.placeholder.Observacoes} name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
            </div>
            <div className="col-md-2 text-left"><button className="btn btn-primary"><i className="fa fa-fw fa-save"></i></button></div>
          </form>
        : 
          <div>{this.state.observations}</div>
        }                
      </div>
    );
  }
}

export default TrainingStaffObservations;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingStaffObservations.js